import { call, select } from 'redux-saga/effects';
import { downloadFile } from 'utils/http/downloadFile';
import { AxiosResponse } from 'axios';
import { selectRoomId } from 'features/room/roomSlice';
import { downloadQuizTemplateService } from 'features/quizzes/services';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';
import * as Sentry from '@sentry/react';

export function* downloadQuizTemplateSaga() {
  try {
    const roomId: string = yield select(selectRoomId);

    const response: AxiosResponse<Blob> = yield call(downloadQuizTemplateService, roomId);
    const contentDisposition = response.headers['content-disposition'];

    yield call(downloadFile, response.data, contentDisposition);
  } catch (error) {
    yield call(notification, i18n.t('notifications:quizzes.template_download_error'));
    Sentry.captureException(error);
  }
}
